import { render } from "./form-wrapper.vue?vue&type=template&id=33c4eebc&scoped=true"
import script from "./form-wrapper.js?vue&type=script&lang=js&external"
export * from "./form-wrapper.js?vue&type=script&lang=js&external"

import "./form-wrapper.scss?vue&type=style&index=0&id=33c4eebc&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c4eebc"]])

export default __exports__